module.exports = __webpack_public_path__ + "static/img/upload.7b62d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/upload.png
// module id = yT8c
// module chunks = 0